module.exports = __webpack_public_path__ + "img/plan-2-b5.6e7ba54a.png";